var React = require('react');

function CloseXMobile (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","fill":"none","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("path",{"d":"M14.081.146L.646 13.581M.646.146l13.435 13.435"})));
}

CloseXMobile.defaultProps = {"width":"15","height":"14","viewBox":"0 0 15 14"};

module.exports = CloseXMobile;

CloseXMobile.default = CloseXMobile;
